<template>
  <div class="main-wrapper-container partnership-page">
    <header-title :main-title="mainTitle" />
    <title-slot title="Условия партнерства"/>
    <Loader v-if="isGlobalLoading"/>
    <pdf-file-input
        v-else
        :active-file="pdfFile"
        @changeFile="onChangePdfFile"
        @removeFile="onRemovePdfFile"
        @clickFile="onClickFile"
    />
  </div>
</template>
<script>
import HeaderTitle from "@/components/entities/HeaderTitle.vue";
import TitleSlot from "@/components/entities/TitleSlot.vue";
import PdfFileInput from "@/components/shared/input/PdfFileInput.vue";
import {api} from "@/middleware/api";
import Loader from "@/components/shared/loader/Loader.vue";
import {mapState} from "vuex";

export default {
  components: {Loader, PdfFileInput, TitleSlot, HeaderTitle},
  name: "PartnershipPage",
  data: () => ({
    mainTitle: "Партнерство",
    pdfFile: null
  }),
  async created() {
    await this.fetchInfo()
  },
  computed: {
    ...mapState(['isGlobalLoading']),
  },
  methods: {
    async fetchInfo() {
      this.IS_GLOBAL_LOADING(true);
      try {
        const {data} = await api.catalogs.catalogsControllerGetCatalogs()
        if (data.items.length > 0) {
          this.pdfFile = {
            ...data.items[0].translations[0]
          }
          this.pdfFile.file.name = data.items[0].translations[0].title
          // const url = await this.getS3Key(this.pdfFile.file.s3Key)
          // const size = await this.getSizeByHead(url)
          // console.log('size', size)
        }

      } catch (e) {

      } finally {
        this.IS_GLOBAL_LOADING(false);
      }
    },
    async onClickFile(file) {
      await api.catalogs.catalogsControllerDownloadFile(file.file.id, file.file.name, {
        format: 'blob'
      })
          .then((response) => {
            this.downloadFileAPI(response)
          });
    },
    downloadFileAPI(response) {
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      window.open(URL.createObjectURL(blob));
    },

    async onChangePdfFile(fileObj) {
      this.pdfFile = fileObj;
      const {data} = await api.dashboard.adminCatalogsControllerCreateCatalog(
          {
            "translations": [
              {
                "title": this.pdfFile.fileName,
                "langCode": "RU"
              }
            ],
            "publishedAt": new Date().toISOString()
          }
      )

      const resFile = await api.dashboard.adminCatalogsControllerUploadFile(data.id, {
        uploadedFile: this.pdfFile.file,
        langCode: 'RU'
      } )
      this.pdfFile = {
        id: data.id,
        ...resFile.data.translations[0]
      }
      this.pdfFile.file.name = resFile.data.translations[0].title
      this.alertSuccess('Файл успешно загружен!')
    },
    async onRemovePdfFile(file) {
      await api.dashboard.adminCatalogsControllerDeleteFile(file.id)
      this.pdfFile = null;
      this.alertSuccess('Файл успешно удален!')
    },
    async getSizeByHead(url) {
      try {
        const res = await fetch(url, { method: 'HEAD' });
        if (!res.ok) throw new Error(res.status + ' ' + res.statusText);
        const len = res.headers.get('content-length');
        return len ? parseInt(len, 10) : null; // null — если заголовка нет
      } catch (e) {
        return null;
      }
    }
  },
}
</script>


<style scoped lang="scss">
.partnership-page{
  max-width: 500px;
}
</style>